import { render } from "./SmsList.vue?vue&type=template&id=132b5194&scoped=true&ts=true"
import script from "./SmsList.vue?vue&type=script&lang=ts"
export * from "./SmsList.vue?vue&type=script&lang=ts"

import "./SmsList.vue?vue&type=style&index=0&id=132b5194&scoped=true&lang=css"
import "./SmsList.vue?vue&type=style&index=1&id=132b5194&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132b5194"]])

export default __exports__